'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, shallowEqual } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PreviewScreenshot from '../PreviewScreenshot';
import OverallResultSection from '../result/OverallResultSection';
import { CTA_OVERALL_BANNER_LINK } from '../../constants/TrialConstants';
import { getDesktopPreview } from '../../selectors/Preview';
import { LanguageCTALinks } from '../../constants/TrialConstants';
import { parseUtmParams } from '../../util/Urls';

var getLangKey = function getLangKey() {
  return window.I18N_MANUAL_LANG;
};

var LangButton = function LangButton() {
  var lang = getLangKey();
  var parsedUtmParams = parseUtmParams();

  if (lang !== 'en') {
    return /*#__PURE__*/_jsx("a", {
      className: "button lg",
      href: LanguageCTALinks[lang] + "&" + parsedUtmParams,
      target: "_blank",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trialBanner.ctaButtonGetGuide"
      })
    });
  }

  return /*#__PURE__*/_jsx("a", {
    className: "button lg",
    href: CTA_OVERALL_BANNER_LINK + "&" + parsedUtmParams,
    target: "_blank",
    rel: "noopener noreferrer",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trialBanner.ctaButtonCourse"
    })
  });
};

export default (function (_ref) {
  var websiteGrade = _ref.websiteGrade;

  var _useSelector = useSelector(getDesktopPreview, shallowEqual),
      url = _useSelector.url,
      error = _useSelector.error;

  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered overall-page",
    id: "overall",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "bg-gradient"
        }), /*#__PURE__*/_jsx(OverallResultSection, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(LangButton, {}), /*#__PURE__*/_jsx(PreviewScreenshot, {
          previewUrl: url,
          error: error
        })]
      })
    })
  });
});